// extracted by mini-css-extract-plugin
module.exports = {"root":"NotFound_root__HU2Kh","title":"NotFound_title__2DPJN"};